module.exports = __webpack_public_path__ + "static/media/image-card-5.b5d55240.png";